<template lang="pug">
.content-wrap.custom-font2
  .content-top
    .con.p-0
      .page
        section.hero(:class="{ 'is-live': isLive, 'zero-flash': zeroFlash }")
          img.hero-pre(
            src="/new/img/migration/hero-banner.webp"
            alt="EPICWIN upgraded website is coming"
          )

          img.hero-live(
            src="/new/img/migration/hero-banner-live.png"
            alt="EPICWIN upgraded website is live now"
          )

          .go-live-burst

          .countdown(:class="{ 'cd-hide': isLive }")
            .unit(
              v-for="item in countdownUnits"
              :key="item.key"
              :class="{'is-seconds': item.key === 'seconds','tick-pulse': tickPulse[item.key] }"
            )
              span.ping

              span.digit(
                :ref="`digit-${item.key}`"
              ) {{ countdown[item.key] }}

          a.login-btn-wrap(
            href="https://epicwin100.com/login"
            target="_blank"
            rel="noopener"
            aria-label="Login now"
          )
            .btn-glow-ring

            .btn-particles
              span.spark(
                v-for="(spark, index) in sparks"
                :key="index"
                :style="spark"
              )

            img.btn-img(
              src="/new/img/migration/login-now-button.webp"
              alt="Login Now"
            )

            .btn-shine

        //- FREE SPINS
        section.free-spins
          img(
            src="/new/img/migration/free-spins-banner.webp"
            alt="EPICWIN players exclusive 18 free spins"
          )

        //- OFFICIAL PARTNERSHIP
        section.partnership
          img.title-img(
            src="/new/img/migration/official-partnership-title.webp"
            alt="Official Partnership"
          )

          img.logos-img(
            src="/new/img/migration/partner-logos.webp"
            alt="Evolution x EpicWin x Pragmatic Play"
          )

          .video-wrap
            .video-inner
              iframe(
                src="https://www.youtube.com/embed/TnQn2YB-djk"
                title="EPICWIN Official Partnership"
                referrerpolicy="strict-origin-when-cross-origin"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen
              )

            img.frame(
              src="/new/img/migration/video-frame.webp"
              alt=""
            )

          img.partner-photo(
            src="/new/img/migration/partner-photo.webp"
            alt="EPICWIN partnership agreement signing with Evolution and Pragmatic Play"
          )

          img.era-highlight(
            src="/new/img/migration/new-era-highlight.webp"
            alt="A new era begins. Today marks the beginning of a new chapter for EPICWIN."
          )

        //- WHY WE UPGRADE
        section.why-upgrade
          img(
            src="/new/img/migration/why-we-upgrade.webp"
            alt="Why we upgrade: Enhanced Security, More Stable Platform, New Rewards System, Official Collaboration, Future Ready"
          )

        //- JOIN COMMUNITY
        section.community
          .community-wrap
            img.banner-img(
              src="/new/img/migration/join-community.webp"
              alt="Join our community. Be the first to know about exclusive updates, rewards and launch events."
            )

            .community-hitboxes
              a(
                href="https://t.me/epicgroupfree100"
                target="_blank"
                rel="noopener"
                aria-label="Join us on Telegram"
              )

              a(
                href="https://chat.whatsapp.com/Iz8Y3IUCaxq7mks2y7qiGy"
                target="_blank"
                rel="noopener"
                aria-label="Join us on WhatsApp"
              )

              a(
                href="https://www.facebook.com/share/g/1AGKhfDmq9/"
                target="_blank"
                rel="noopener"
                aria-label="Follow us on Facebook"
              )

        //- FAQ
        section.faq-section
          h2.faq-heading FAQ

          .faq-item(
            v-for="(faq, index) in faqs"
            :key="index"
            :class="{ open: openFaq === index }"
          )
            button.faq-question(
              type="button"
              @click="toggleFaq(index)"
            )
              span {{ index + 1 }}. {{ faq.question }}
              span.chev

            .faq-answer(
              :style="faqAnswerStyle(index)"
            )
              .faq-answer-inner(
                :ref="`faq-${index}`"
              )
                p {{ faq.answer }}

        footer © 2026 EPICWIN. All rights reserved.
</template>
<script>
export default{
  data() {
    return {
      targetTime: new Date('2026-09-01T12:00:00+08:00').getTime(),

      timer: null,

      isLive: false,
      zeroFlash: false,

      countdown: {
        days: '00',
        hours: '00',
        minutes: '00',
        seconds: '00'
      },

      tickPulse: {
        days: false,
        hours: false,
        minutes: false,
        seconds: false
      },

      countdownUnits: [
        {
          key: 'days'
        },
        {
          key: 'hours'
        },
        {
          key: 'minutes'
        },
        {
          key: 'seconds'
        }
      ],

      openFaq: 0,

      sparks: [
        {
          left: '20%',
          '--dx0': '-30px',
          '--dx1': '-55px',
          '--d': '2.3s',
          '--del': '0s'
        },
        {
          left: '80%',
          '--dx0': '30px',
          '--dx1': '55px',
          '--d': '2.6s',
          '--del': '.3s'
        },
        {
          left: '35%',
          '--dx0': '-10px',
          '--dx1': '-20px',
          '--d': '2.1s',
          '--del': '.6s'
        },
        {
          left: '65%',
          '--dx0': '10px',
          '--dx1': '20px',
          '--d': '2.8s',
          '--del': '.9s'
        },
        {
          left: '50%',
          '--dx0': '0px',
          '--dx1': '0px',
          '--d': '2.4s',
          '--del': '1.2s'
        },
        {
          left: '10%',
          '--dx0': '-45px',
          '--dx1': '-80px',
          '--d': '2.9s',
          '--del': '1.5s'
        },
        {
          left: '90%',
          '--dx0': '45px',
          '--dx1': '80px',
          '--d': '2.2s',
          '--del': '1.8s'
        }
      ],

      faqs: [
        {
          question: 'Why is EPICWIN upgrading its website?',
          answer:
            'To provide a more secure platform, exciting new features, and a better gaming experience through our official partnership with Evolution and Pragmatic Play.'
        },
        {
          question: 'Do I need to register a new account?',
          answer:
            'No. Your existing EPICWIN account will be migrated automatically. Simply log in after the upgraded website launches.'
        },
        {
          question: 'How do I claim my 18 Free Spins?',
          answer:
            'Log in with your existing account after launch. Your 18 Free Spins will be credited automatically.'
        },
        {
          question: 'Will my account information remain?',
          answer:
            'Yes. Your account information will be migrated automatically, except your bank details, which must be added again for security purposes.'
        },
        {
          question: 'What happens to my account balance?',
          answer:
            'Please withdraw your balance before the upgraded website launches. Your balance will not be migrated.'
        },
        {
          question: 'When can I log in to the upgraded website?',
          answer:
            'You can log in once the upgraded website officially launches on 1 September 2026, 12:00 PM.'
        },
        {
          question: 'Is this the official EPICWIN website?',
          answer:
            'Yes. This is the official EPICWIN platform upgrade. Always access it through our official website, community channels, or Customer Service Live Chat.'
        }
      ]
    }
  },
  computed:{
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
  },
  mounted(){
    window.scroll(0,0)
    document.body.classList.add("custom-padding");
    this.tick()

    this.timer = setInterval(() => {
      this.tick()
    }, 1000)

    // Same preview functionality as your original:
    // ?zero=1
    const params = new URLSearchParams(window.location.search)

    if (params.get('zero') === '1') {
      this.goLive()
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  },
  methods: {
    pad(value) {
      return value < 10 ? `0${value}` : `${value}`
    },

    tick() {
      let diff = this.targetTime - Date.now()

      if (diff < 0) {
        diff = 0
      }

      const days = Math.floor(
        diff / (1000 * 60 * 60 * 24)
      )

      const hours = Math.floor(
        (diff % (1000 * 60 * 60 * 24)) /
          (1000 * 60 * 60)
      )

      const minutes = Math.floor(
        (diff % (1000 * 60 * 60)) /
          (1000 * 60)
      )

      const seconds = Math.floor(
        (diff % (1000 * 60)) / 1000
      )

      this.updateCountdown('days', this.pad(days))
      this.updateCountdown('hours', this.pad(hours))
      this.updateCountdown('minutes', this.pad(minutes))
      this.updateCountdown('seconds', this.pad(seconds))

      if (diff <= 0) {
        this.goLive()
      }
    },

    updateCountdown(key, newValue) {
      if (this.countdown[key] === newValue) {
        return
      }

      this.animateDigit(key, newValue)
      this.triggerTickPulse(key)
    },

    animateDigit(key, newValue) {
      const ref = this.$refs[`digit-${key}`]
      const el = Array.isArray(ref) ? ref[0] : ref

      if (!el) {
        this.countdown[key] = newValue
        return
      }

      el.style.transition =
        'transform .16s cubic-bezier(.4,0,1,1)'

      el.style.transform = 'rotateX(-90deg)'

      setTimeout(() => {
        this.countdown[key] = newValue

        this.$nextTick(() => {
          el.style.transition = 'none'
          el.style.transform = 'rotateX(90deg)'

          // Force reflow
          void el.offsetHeight

          el.style.transition =
            'transform .18s cubic-bezier(0,0,.2,1)'

          el.style.transform = 'rotateX(0deg)'
        })
      }, 160)
    },

    triggerTickPulse(key) {
      this.$set(this.tickPulse, key, false)

      this.$nextTick(() => {
        this.$set(this.tickPulse, key, true)

        setTimeout(() => {
          this.$set(this.tickPulse, key, false)
        }, 600)
      })
    },

    goLive() {
      if (this.isLive) {
        return
      }

      this.isLive = true
      this.zeroFlash = true

      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }

      setTimeout(() => {
        this.zeroFlash = false
      }, 1000)
    },

    toggleFaq(index) {
      if (this.openFaq === index) {
        this.openFaq = null
      } else {
        this.openFaq = index
      }
    },

    faqAnswerStyle(index) {
      if (this.openFaq !== index) {
        return {
          maxHeight: '0px'
        }
      }

      const ref = this.$refs[`faq-${index}`]
      const el = Array.isArray(ref) ? ref[0] : ref

      if (!el) {
        return {
          maxHeight: '500px'
        }
      }

      return {
        maxHeight: `${el.scrollHeight}px`
      }
    }
  }
}
</script>
<style lang="scss" scoped>
// :root {
//   --purple-deep: #2c0a5e;
//   --purple-pill: #3d0a70;
//   --purple-pill-light: #4a1188;
//   --gold: #ffd23f;
// }

.content-wrap{
  padding-left: 0;
}

* {
  box-sizing: border-box;
}

html,
body {
  margin: 0;
  padding: 0;
  background: #07020f;
}

body {
  font-family: 'Segoe UI', Arial, Helvetica, sans-serif;
  color: #fff;
}

.page {
  width: 100%;
  max-width: 520px; 
  margin: 0 auto;
  background: #07020f;
  overflow: hidden;
  position: relative;
}

.page img {
  display: block;
  max-width: 100%;
  height: auto;
}

/* HERO */

.hero {
  position: relative;
  aspect-ratio: 1080 / 882;
  overflow: hidden;
}

.hero.is-live {
  aspect-ratio: 1080 / 793;
}

.hero img {
  width: 100%;
}

.hero-pre {
  position: relative;
  z-index: 1;
}

.hero-live {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  z-index: 2;
  opacity: 0;
  pointer-events: none;
}

.hero.is-live .hero-live {
  opacity: 1;
}

.go-live-burst {
  position: absolute;
  inset: 0;
  z-index: 3;
  pointer-events: none;
  opacity: 0;
  background:
    radial-gradient(
      circle at 50% 62%,
      rgba(255,255,255,.9) 0%,
      rgba(180,255,200,.75) 22%,
      rgba(57,255,106,.55) 45%,
      rgba(57,255,106,0) 72%
    );
}

.hero.zero-flash .go-live-burst {
  animation: goLiveFlash 1s ease forwards;
}

@keyframes goLiveFlash {
  0% {
    opacity: 0;
  }

  14% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

.hero.zero-flash {
  animation:
    goLiveShake
    .55s
    cubic-bezier(.36,.07,.19,.97)
    .12s
    1;
}

@keyframes goLiveShake {
  0%,
  100% {
    transform: translate(0,0);
  }

  15% {
    transform: translate(-7px,3px);
  }

  30% {
    transform: translate(6px,-4px);
  }

  45% {
    transform: translate(-5px,3px);
  }

  60% {
    transform: translate(4px,-2px);
  }

  75% {
    transform: translate(-2px,1px);
  }
}

/* COUNTDOWN */

.countdown {
  position: absolute;
  left: 7.2%;
  right: 6.8%;
  top: 59.6%;
  display: flex;
  justify-content: space-between;
  gap: 2.6%;
  transition: opacity .35s ease;
  z-index: 4;
}

.countdown.cd-hide {
  opacity: 0;
  pointer-events: none;
}

.countdown .unit {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  aspect-ratio: 1 / .82;
  perspective: 220px;
  position: relative;
  border-radius: 12px;
}

.countdown .unit .digit {
  display: inline-block;
  font-family: Arial, Helvetica, sans-serif;
  font-weight: 800;
  font-style: italic;
  color: #0a0a0a;
  -webkit-text-stroke: 1px #39ff6a;
  font-size: 11.5vw;
  line-height: 1;
  padding-top: .1em;
  text-shadow:
    0 0 4px #39ff6a,
    0 0 10px #39ff6a,
    0 0 18px #2bff57,
    0 0 32px #17e63f,
    0 2px 3px rgba(0,0,0,.6);
  backface-visibility: hidden;
  transform-style: preserve-3d;
  will-change: transform;
}

@media (min-width: 520px) {
  .countdown .unit .digit {
    font-size: 58px;
  }
}

.countdown .unit.tick-pulse {
  animation:
    cdTickPulse
    .4s
    cubic-bezier(.34,1.56,.64,1);
}

@keyframes cdTickPulse {
  0% {
    transform: scale(1);
    filter: brightness(1);
  }

  28% {
    transform: scale(1.14);
    filter: brightness(1.35);
  }

  100% {
    transform: scale(1);
    filter: brightness(1);
  }
}

.countdown .unit .ping {
  position: absolute;
  inset: -3px;
  border-radius: 14px;
  border: 2px solid #39ff6a;
  opacity: 0;
  pointer-events: none;
  z-index: 4;
}

.countdown .unit.tick-pulse .ping {
  animation: cdPing .6s ease-out;
}

@keyframes cdPing {
  0% {
    transform: scale(.92);
    opacity: .9;
  }

  100% {
    transform: scale(1.4);
    opacity: 0;
  }
}

.countdown .unit.is-seconds {
  animation: cdHeartbeat 1s ease-in-out infinite;
}

@keyframes cdHeartbeat {
  0%,
  100% {
    box-shadow: 0 0 0 0 rgba(57,255,106,0);
  }

  50% {
    box-shadow: 0 0 16px 3px rgba(57,255,106,.45);
  }
}

/* LOGIN BUTTON */

.login-btn-wrap {
  position: absolute;
  left: 50%;
  top: 79%;
  width: 56%;
  transform: translate(-50%, calc(-50% + 14px));
  z-index: 4;
  display: block;
  opacity: 0;
  pointer-events: none;
  transition:
    opacity .4s ease .15s,
    transform .4s cubic-bezier(.34,1.56,.64,1) .15s;
}

.hero.is-live .login-btn-wrap {
  opacity: 1;
  transform: translate(-50%,-50%);
  pointer-events: auto;
}

.login-btn-wrap img {
  width: 100%;
}

.btn-glow-ring {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 220%;
  height: 320%;
  transform: translate(-50%,-50%) scale(.85);
  background:
    radial-gradient(
      ellipse at center,
      rgba(255,213,74,.35) 0%,
      rgba(255,213,74,0) 65%
    );
  pointer-events: none;
  opacity: .15;
  z-index: 0;
}

.hero.is-live .btn-glow-ring {
  animation: btnRingPulse 2.2s ease-in-out .9s infinite;
}

@keyframes btnRingPulse {
  0% {
    opacity: .15;
    transform: translate(-50%,-50%) scale(.85);
  }

  50% {
    opacity: .55;
    transform: translate(-50%,-50%) scale(1.05);
  }

  100% {
    opacity: .15;
    transform: translate(-50%,-50%) scale(.85);
  }
}

.btn-img {
  position: relative;
  z-index: 1;
  display: block;
}

.hero.is-live .btn-img {
  animation: btnBreathe 2.1s ease-in-out .9s infinite;
}

@keyframes btnBreathe {
  0%,
  100% {
    filter:
      drop-shadow(0 0 10px rgba(255,213,74,.55))
      drop-shadow(0 0 22px rgba(255,180,0,.35));
  }

  50% {
    filter:
      drop-shadow(0 0 24px rgba(255,213,74,.95))
      drop-shadow(0 0 46px rgba(255,180,0,.6));
  }
}

.btn-shine {
  position: absolute;
  top: 0;
  left: -60%;
  width: 40%;
  height: 100%;
  background:
    linear-gradient(
      115deg,
      transparent 0%,
      rgba(255,255,255,.75) 50%,
      transparent 100%
    );
  transform: skewX(-20deg);
  pointer-events: none;
  z-index: 2;
  opacity: 0;
  overflow: hidden;
}

.hero.is-live .btn-shine {
  opacity: 1;
  animation:
    btnShineSweep
    2.6s
    ease-in-out
    1.1s
    infinite;
}

@keyframes btnShineSweep {
  0% {
    left: -60%;
  }

  100% {
    left: 140%;
  }
}

.btn-particles {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 2;
  overflow: visible;
}

.btn-particles .spark {
  position: absolute;
  left: 50%;
  top: 40%;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #ffe27a;
  box-shadow: 0 0 8px 2px rgba(255,213,74,.8);
  opacity: 0;
}

.hero.is-live .btn-particles .spark {
  animation:
    btnSpark
    var(--d, 2.6s)
    ease-out
    var(--del, 0s)
    infinite;
}

@keyframes btnSpark {
  0% {
    opacity: 0;
    transform:
      translate(var(--dx0, 0), 0)
      scale(.4);
  }

  15% {
    opacity: 1;
  }

  100% {
    opacity: 0;
    transform:
      translate(var(--dx1, 0), -70px)
      scale(1);
  }
}

/* FREE SPINS */

.free-spins {
  padding: 11px 16px 3px;
}

/* PARTNERSHIP */

.partnership {
  padding: 17px 16px 10px;
  text-align: center;
}

.partnership .title-img {
  // max-width: 320px;
  max-width: 100%;
  margin: 0 auto 11px;
}

.partnership .logos-img {
  // max-width: 340px;
  max-width: 100%;
  margin: 0 auto 26px;
}

.video-wrap {
  position: relative;
  width: 92%;
  // max-width: 440px;
  max-width: 100%;
  margin: 0 auto 30px;
}

.video-wrap img.frame {
  width: 100%;
  position: relative;
  z-index: 2;
  pointer-events: none;
}

.video-wrap .video-inner {
  position: absolute;
  top: 6.2%;
  left: 2.6%;
  right: 2.6%;
  bottom: 6.2%;
  z-index: 3;
  border-radius: 10px;
  overflow: hidden;
  background: #000;
}

.video-wrap .video-inner iframe {
  width: 100%;
  height: 100%;
  border: 0;
  display: block;
}

.partner-photo {
  margin: 0 auto 26px;
  // max-width: 460px;
  max-width: 100%;
}

.era-highlight {
  width: 100%;
  // max-width: 460px;
  max-width: 100%;
  margin: 0 auto;
  display: block;
}

/* WHY UPGRADE */

.why-upgrade {
  padding: 36px 0 10px;
}

.why-upgrade img {
  width: 100%;
  display: block;
}

/* COMMUNITY */

.community {
  padding: 30px 16px 10px;
}

.community-wrap {
  position: relative;
}

.community .banner-img {
  display: block;
  width: 100%;
}

.community-hitboxes {
  position: absolute;
  left: 0;
  right: 0;
  top: 81%;
  bottom: 1.5%;
  display: flex;
  gap: 1.8%;
}

.community-hitboxes a {
  flex: 1;
  display: block;
  border-radius: 8px;
}

.community-hitboxes a:focus-visible {
  outline: 2px solid #fff;
}

/* FAQ */

.faq-section {
  padding: 40px 16px 50px;
}

.faq-heading {
  text-align: center;
  font-size: 26px;
  font-weight: 800;
  font-style: italic;
  letter-spacing: .5px;
  color: #fff;
  text-shadow:
    0 0 14px rgba(168,85,247,.85),
    0 0 28px rgba(168,85,247,.5);
  margin-bottom: 22px;
}

.faq-item {
  margin-bottom: 14px;
}

.faq-question {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
  background:
    linear-gradient(
      180deg,
      #4a1188,
      #3d0a70
    );
  border: none;
  border-radius: 14px;
  padding: 16px 18px;
  color: #fff;
  font-size: 14.5px;
  font-weight: 700;
  text-align: left;
  cursor: pointer;
  box-shadow: 0 3px 0 rgba(0,0,0,.25);
}

.faq-question .chev {
  flex: none;
  width: 14px;
  height: 14px;
  border-right: 2.5px solid #fff;
  border-bottom: 2.5px solid #fff;
  transform: rotate(45deg);
  transition: transform .25s ease;
  margin-top: -4px;
}

.faq-item.open .faq-question .chev {
  transform: rotate(225deg);
  margin-top: 4px;
}

.faq-answer {
  max-height: 0;
  overflow: hidden;
  transition: max-height .3s ease;
}

.faq-answer p {
  margin: 0;
  padding: 14px 18px 4px;
  font-size: 13.5px;
  line-height: 1.65;
  color: #cdc5df;
}

footer {
  text-align: center;
  padding: 0 16px 34px;
  font-size: 11.5px;
  color: #7a7190;
}
</style>